/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import MainPage from '../../MainPage';
import { useSelector } from 'react-redux';
import { EditIcon } from '../Common/Icons';
import './Groups.less';
import { message, Tabs } from 'antd';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import GroupBannerInfo from './GroupBannerInfo';
import GroupSchedule from './GroupSchedule';
import GroupMember from './GroupMember';
import { GroupModalActions } from '@vantiva-sa/homesight_humaui/Utilities/Constants';
import { SingleDatePicker } from '../Common/HSWidget'; // Changed to HSWidget version
import { DateFormat } from '@vantiva-sa/homesight_humaui/Utilities/Constants'; // Added DateFormat import
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { AddPlusIcon } from '../Common/Icons';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import {
  getDateFormatISO,
  getTimeZoneFormat,
} from '@vantiva-sa/homesight_humaui/Utilities/DateTime';
import { truncateStringWith3Dots } from '@vantiva-sa/homesight_humaui/Utilities/CommonUtilities';

// Enable timezone plugin
dayjs.extend(utc);
dayjs.extend(timezone);

const GroupDetails = ({
  parentBread,
  record,
  onGroupModalActionClick,
  timeZone,
  groupName,
  setShowRemoveMemberConfirmModal,
  setScheduleModalData,
  userInfo,
  refreshSchedulePage,
  GroupDetails,
  setRemoveMemberUuid,
  setRemoveMemberName,
  isStaffAdmin,
  isStaff,
  loginUserTimeformat,
}) => {
  const header = parentBread || [];
  const trans = useSelector(translator);

  const [activeTab, setActiveTab] = useState('1');
  const [scheduleEvents, setScheduleEvents] = useState([]);
  const [loadingSchedule, setLoadingSchedule] = useState(false);
  const [loadingMember, setLoadingMember] = useState(false);
  const [setupBanner, setSetupBanner] = useState(false);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

  const userTimezone = userInfo?.timezone
    ? getTimeZoneFormat(userInfo.timezone)
    : Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentDate = dayjs().tz(userTimezone);
  const [selectedDate, setSelectedDate] = useState(currentDate);
  const scheduleApi = useSelector((state) => state.apis.scheduleApi);

  const errorCallback = (error) => {
    // message.error(error);
    console.error(error);
    setLoadingSchedule(false);
  };

  const successCallback = (data) => {
    setLoadingSchedule(false);
    setHasLoadedOnce(true);
    // Store the schedule events in state
    if (data && data.schedule_events) {
      setScheduleEvents(data.schedule_events);
    } else {
      setScheduleEvents([]);
    }
  };

  useEffect(() => {
    if (!record?.groupuuid || !selectedDate) return;
    setLoadingSchedule(true);
    const selectedDateStr = dayjs(selectedDate).tz(userTimezone).format('YYYY-MM-DD');
    const endDateTime = `${selectedDateStr}T23:59:59.000Z`;
    const startDateTime = `${selectedDateStr}T00:00:00.000Z`;
    const opts = { timezone: timeZone, status: true };

    try {
      scheduleApi.eventsByUsergroupTimeRange(
        record?.groupuuid,
        startDateTime,
        endDateTime,
        opts,
        apiCallback({
          failCallback: errorCallback,
          errorCallback,
          successCallback,
        })
      );
    } catch (error) {
      errorCallback(error);
    }
  }, [record, selectedDate, timeZone, refreshSchedulePage]);

  useEffect(() => {
    if (activeTab === '2' && record?.groupuuid) {
      setLoadingMember(true);
      setTimeout(() => {
        setLoadingMember(false);
      }, 1000);
    }
  }, [activeTab, record?.groupuuid]);

  const addMemberHandler = () => {
    onGroupModalActionClick(GroupModalActions.addMember);
  };

  // Fixed date selection handler
  const handleDateSelect = (date) => {
    if (!date) {
      console.error('No date passed to handleDateSelect:', date);
      return;
    }
    const dayjsDate = dayjs.isDayjs(date) ? date : dayjs(date);
    // Validate the date
    if (!dayjsDate.isValid()) {
      console.error('Invalid date passed to handleDateSelect:', date);
      return;
    }
    const normalizedDate = dayjsDate.startOf('day').toDate();
    setSelectedDate(normalizedDate);
  };

  // Custom tab bar with conditional content based on active tab
  const renderTabBar = (props, DefaultTabBar) => (
    <div className="group-tabs-with-date-picker">
      <DefaultTabBar {...props} />
      {activeTab === '1' && (
        <div className="group-date-picker-in-tabs">
          <SingleDatePicker
            DateFormat={DateFormat}
            timeZone={userTimezone}
            defaultValue={selectedDate ? selectedDate : null}
            onDateSelect={handleDateSelect}
            value={selectedDate ? selectedDate : null}
            className="group-single-date-picker"
            allowClear={false}
            style={{ width: '200px' }}
          />
        </div>
      )}
      {activeTab === '2' && (
        <div className="group-date-picker-in-tabs">
          <div className="groups-add-member-button-container">
            {isStaffAdmin ? (
              <div className="groups-add-member-button" onClick={addMemberHandler}>
                <AddPlusIcon className="groups-member-plus-icon" />
                <span className="groups-add-member-label">{trans('ADDMEMBER')}</span>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <MainPage hasSider={true} header={header}>
      <div className="listgroup-wrapper group-page-content-wrapper">
        <div className="group-page-header-container">
          <div className="group-page-header">
            <span className="group-page-header-text">{truncateStringWith3Dots(groupName, 70)}</span>

            {isStaffAdmin ? (
              <button
                className="edit-group-btn"
                onClick={() => onGroupModalActionClick(GroupModalActions.editGroup)}
              >
                <div className="edit-group-icon">
                  <EditIcon style={{ width: '18' }} />
                </div>
                <span className="edit-group-text"> {trans('EDITGROUP_U')}</span>
              </button>
            ) : null}
          </div>
        </div>
        {hasLoadedOnce && !loadingSchedule && (
          <GroupBannerInfo
            record={record}
            scheduleEvents={scheduleEvents}
            onGroupModalActionClick={onGroupModalActionClick}
            setSetupBanner={setSetupBanner}
            setActiveTab={setActiveTab}
            isStaffAdmin={isStaffAdmin}
            isStaff={isStaff}
          />
        )}
        <div className="content-header">
          <div style={{ display: 'flex', 'justify-content': 'flex-start', padding: '10px 0 10px' }}>
            <div className="group-title-container" style={{ padding: '10px' }}>
              <span className="group-title">{trans('DESCRIPTION')}</span>
              <span className="group-list-subtitle">{record?.description}</span>
            </div>
          </div>
        </div>

        <div className="group-tabs-container">
          <Tabs
            defaultActiveKey="1"
            activeKey={activeTab}
            onChange={handleTabChange}
            className="group-tabs"
            tabPosition="top"
            renderTabBar={renderTabBar}
            items={[
              {
                label: trans('SCHEDULE'),
                key: '1',
                children: (
                  <GroupSchedule
                    onGroupModalActionClick={onGroupModalActionClick}
                    selectedDate={selectedDate}
                    scheduleEvents={scheduleEvents}
                    timeZone={timeZone}
                    loading={loadingSchedule}
                    setScheduleModalData={setScheduleModalData}
                    userInfo={userInfo}
                    groupName={groupName}
                    isStaffAdmin={isStaffAdmin}
                    setupBanner={setupBanner}
                    isStaff={isStaff}
                    loginUserTimeformat={loginUserTimeformat}
                  />
                ),
              },
              {
                label: trans('MEMBERS'),
                key: '2',
                children: (
                  <GroupMember
                    setShowRemoveMemberConfirmModal={setShowRemoveMemberConfirmModal}
                    record={record}
                    loading={loadingMember}
                    isStaffAdmin={isStaffAdmin}
                    setRemoveMemberUuid={setRemoveMemberUuid}
                    setRemoveMemberName={setRemoveMemberName}
                    setupBanner={setupBanner}
                  />
                ),
              },
            ]}
          />
        </div>
      </div>
    </MainPage>
  );
};

GroupDetails.propTypes = {
  parentBread: PropTypes.arrayOf(PropTypes.object),
  record: PropTypes.object,
  onGroupModalActionClick: PropTypes.func,
  timeZone: PropTypes.string,
  groupName: PropTypes.string,
  setShowRemoveMemberConfirmModal: PropTypes.func,
  setScheduleModalData: PropTypes.func,
  userInfo: PropTypes.object,
};

export default GroupDetails;
